/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */

import React, { useState } from 'react';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Container } from './styles';
import logo from '~/assets/logo_header_neg-2x.png';
import PDF from '~/pages/Catalogo/catalogo digital_2026_novo.pdf';
import api from '../../services/api';

import GDPRPanel from '~/components/GDPRPanel';
import WhastFooter from '~/components/WhastFooter';
import Tiktok from '~/assets/tiktok-black.png';
import Amazon from '~/assets/AMAZON_PRETO.svg';

function Footer() {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState('');
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [assunto, setAssunto] = useState('');
    const [assuntoError, setAssuntoError] = useState('');
    const [duvida, setDuvida] = useState('');
    const [duvidaError, setDuvidaError] = useState('');
   
    let messageNameError = '';
    let messageEmailError = '';
    let messageAssuntoError = '';
    let messageDuvidaError = '';
    
    let name_clear = document.querySelector('.name-clear');
    let email_clear = document.querySelector('.email-clear');
    let assunto_clear = document.querySelector('.assunto-clear');
    let mensagem_clear = document.querySelector('.mensagem-clear');
  
    if(name.length > 0 && name.length < 3) {
      messageNameError = <div className="validation-inputs size-font-error text-danger">Mínimo 3 caracteres!</div>
      if(name_clear != undefined || name_clear != null ){
        name_clear.innerHTML = ''
        name_clear.classList.remove('name-clear')
      }
    }
    if(email.length !== 0){
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 0 && email.length < 7) {
        messageEmailError = <div className="validation-inputs size-font-error text-danger">E-mail deve conter "@" e "." e ter no mínimo 7 caracteres</div>
        if(email_clear != undefined || email_clear != null){
          email_clear.innerHTML = ''
          email_clear.classList.remove('email-clear')
        }
      }
    }
    if(assunto.length > 0 && assunto.length < 5) {
      messageAssuntoError = <div className="validation-inputs size-font-error text-danger">Mínimo 5 caracteres!</div>
      if(assunto_clear != undefined || assunto_clear != null){
        assunto_clear.innerHTML = ''
        assunto_clear.classList.remove('assunto-clear')
      }
    }
    if(duvida.length > 0 && duvida.length < 10) {
      messageDuvidaError = <div className="validation-inputs size-font-error text-danger">Mínimo 10 caracteres!</div>
      if(mensagem_clear != undefined || mensagem_clear != null){
        mensagem_clear.innerHTML = ''
        mensagem_clear.classList.remove('mensagem-clear')
      }
    }
  

  let button;
  if (loading) {
    button = (
      <div className="btn mb-2">
        <div className="loader" />
      </div>
    );
  } else {
    button = (
      <button type="submit" className="btn mb-2" >
        Enviar
      </button>
    );
  }
  

  const handleSubmit = async event => {
    setLoading(true);
    event.preventDefault();

    const form = event.target;
      const formData = new FormData(form);
      const response = await api.post('/contato', formData);
      setLoading(false);
      form.reset();
      if (response.status === 200) {
        const resultado = response.data.split("-");
        if(resultado[0] === 'E'){
          const messageDiv = (
            <div className="alert alert-success">Mensagem enviada com sucesso!</div>
          );
          setName('');
          setEmail('');
          setAssunto('');
          setDuvida('');  
          setMessage(messageDiv);
          
        }else{
          const messageDiv = (
            <div className="alert alert-danger">Erro ao enviar a mensagem!</div>
          );
          setMessage(messageDiv);
          const existErrorName = resultado.includes('Nome obrigatório')
          const existErrorEmail = resultado.includes('Email obrigatório')
            const existErrorAssunto = resultado.includes('Assunto obrigatório')
          const existErrorMensagem = resultado.includes('Mensagem obrigatório')
          if(existErrorName){
            setNameError('')
            messageNameError = (
              <div className="validation-inputs text-danger mb-1 size-font-error name-clear">Nome obrigatório</div>
            )
            setNameError(messageNameError)
          }else{
            setNameError('')
          }
          if(existErrorEmail){
            setEmailError('')
            messageEmailError = (
              <div className="validation-inputs text-danger mb-1 size-font-error email-clear">Email obrigatório</div>
            )
            setEmailError(messageEmailError)
          }else{
            setEmailError('')
          }
          
          if(existErrorAssunto){
            setAssuntoError('')
            messageAssuntoError = (
              <div className="validation-inputs text-danger mb-1 size-font-error assunto-clear">Assunto obrigatório</div>
            )
            setAssuntoError(messageAssuntoError)
          }else{
            setAssuntoError('')
          }
          
          if(existErrorMensagem){
            messageDuvidaError = (
              <div className="validation-inputs text-danger mb-1 size-font-error mensagem-clear">Mensagem obrigatório</div>
            )
            setDuvidaError(messageDuvidaError)
          }else{
            setDuvidaError('')
          }
        }
      }
    
  };

  return (
    <>
      <WhastFooter />
      <Container>
        <div className="container fundo p-0">
          <nav className="navbar navbar-expand-md py-2 desk-only col">
            <ul className="navbar-nav justify-content-between p-0 w-100">
              <li className="nav-item">
                <Link to={`${process.env.PUBLIC_URL}/`} className="nav-link">
                  HOME
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to={`${process.env.PUBLIC_URL}/empresa-de-cosmeticos`}
                  className="nav-link"
                >
                  QUEM SOMOS
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to={`${process.env.PUBLIC_URL}/produtos`}
                  className="nav-link"
                >
                  PRODUTOS
                </Link>
              </li>
              <li className="nav-item">
                <a
                  href={PDF}
                  target="_blank"
                  rel="noreferrer"
                  className="nav-link m-auto"
                >
                  CATÁLOGO
                </a>
              </li>
              <li className="nav-item">
                <Link
                  to={`${process.env.PUBLIC_URL}/onde-encontrar`}
                  className="nav-link"
                >
                  ONDE ENCONTRAR
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to={`${process.env.PUBLIC_URL}/contato`}
                  className="nav-link"
                >
                  CONTATO
                </Link>
              </li>
            </ul>
          </nav>
          <div className="d-flex px-2">
            <div className="col coluna-contato">
              <div className="">
                <img src={logo} alt="Logo Anaconda" className="my-4 logo" />
                <p className="text-justify desc-anaconda">
                  A Anaconda Cosméticos é uma empresa 100% nacional com
                  tecnologias francesas, alemãs e americanas de alta performance
                  e distribuição em todo território nacional.
                </p>
              </div>
              <div className=" formas-contato">
                <h6 className="col-12 p-0 m-0">Endereço</h6>
                <p>
                  Av. Celso Garcia, 676 <br /> São Paulo – SP
                </p>
                <h6 className="col-12 p-0 m-0">Telefone</h6>
                <a href="tel:+551126187766" className="text-black">
                  {' '}
                  011 – 2618-7766
                </a>
                <h6 className="col-12 p-0 m-0">Email</h6>
                <a
                  href="mailto:fabrica.anaconda@gmail.com"
                  className="text-break text-black"
                >
                  {' '}
                  fabrica.anaconda@gmail.com
                </a>
              </div>
              <div className="">
                <a href="https://www.amazon.com.br/stores/page/7571F5F3-149A-494E-9052-1469B42EA5B2?ref_=cm_sw_r_ud_sf_stores_E7VMM4Y78YVC5AE5PBCG">
                  <img src={Amazon} alt="Amazon" style={{ marginRight: '16px', width: "25px" }} />
                </a>
                <a href="https://www.tiktok.com/@anaconda.cosmeticos">
                  <img src={Tiktok} alt="tiktok" style={{ marginRight: '16px', width: "24px" }} />
                </a>
                <a
                  href="https://www.facebook.com/Anaconda-Cosm%C3%A9ticos-109160597287290/"
                  className=""
                >
                  <FaFacebookF size={24} color="#000" />
                </a>
                <a
                  href="https://www.instagram.com/anacondacosmeticosoficial/"
                  className=" ml-4" target='_blank'
                >
                  <FaInstagram size={24} color="#000" />
                </a>
              </div>
            </div>
            <div className="col-7 ml-auto desk-only">
              <h4 className="my-4 ml-0">CONTATO</h4>

              <div className="container p-0">
                <form
                  onSubmit={handleSubmit}
                  id="form-contato"
                  encType="multipart/form-data"
                >
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control mb-1 "
                      id="nome"
                      placeholder="Digite seu nome *"
                      name="nome"
                      // required
                      onChange={(e)=> setName(e.target.value)}
                      value={name}
                      />
                  {messageNameError}
                  {nameError}
                  </div>
                  <div className="form-group ">
                    <input
                      type="email"
                      className="form-control mt-4 mb-1"
                      id="email"
                      placeholder="Seu email *"
                      name="email"
                      // required
                      onChange={(e)=> setEmail(e.target.value)}
                      value={email}
                    />
                    {messageEmailError}
                    {emailError}
                  </div>
                    
                  <div className="form-group">
                  <input
                    type="text"
                    className="form-control  mt-4 mb-1 d-none"
                    id="assunto"
                    placeholder="Qual o assunto? *"
                    name="assunto"
                    // required
                    onChange={(e)=> setAssunto(e.target.value)}
                    value={(assunto === '') ? 'Mensagem de dúvida do site' : assunto}
                  />
                {messageAssuntoError}
                {assuntoError}
                </div>
                  <div className="form-group">
                    <textarea
                      className="form-control mt-4 mb-1"
                      id="duvida"
                      rows="3"
                      placeholder="Qual é a sua dúvida? *"
                      name="mensagem"
                      // required
                      onChange={(e)=> setDuvida(e.target.value)}
                      value={duvida}
                    />
                    {messageDuvidaError}
                    {duvidaError}
                  </div>
                  <div className="mb-2">
                    <small className='mb-1'>
                      * Campos obrigatórios
                    </small>
                  </div>
                  {button}
                </form>
                {message}
              </div>
            </div>
          </div>
          <div className="mt-4 text-center">
            <small>@ ANACONDA COSMÉTICOS | TODOS OS DIREITOS RESERVADOS</small>
          </div>
          <div className="mt-2 text-center">
            <a
              className="mt-2 text-center nav-link m-auto"
              href={'https://amzmp.com.br/'}
              target="_blank"
              rel="noreferrer"
            >
              <small>Criado por: amz|mp</small>
            </a>
          </div>
        </div>
      </Container>
      <GDPRPanel />
    </>
  );
}

export default Footer;
